<script>
import Layout from "../../layouts/main";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      searchQuery: "",
      products: [],
      currentPage: 1,
      itemsPerPage: 20,
      showPopup: false,
      showEditPopup: false,
      showDeletePopup: false,
      newProduct: {
        name: "",
        description: "",
        price: "",
        price_2: " ",
        currency: "MXN",
        user_id: 1,
        subcategory_id: null, // Aseguramos que la subcategoría se seleccione
      },
      editProduct: {
        id: null,
        name: "",
        description: "",
        price: "",
        price_2: "0.00",
        currency: "MXN",
        user_id: 1,
        subcategory_id: null, // Se maneja de manera similar
      },
      subcategories: [
      ], // Lista de subcategorías
      deleteProductId: null,
      isLoading: false,
      isEditing: false,
      isDeleting: false
    };
  },
  computed: {
    filteredProducts() {
      return this.products.filter(product =>
        product.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProducts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    }
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await fetch("https://humobarculinario.com/api/productos.php");
        if (!response.ok) {
          throw new Error("Error al obtener los productos");
        }
        const data = await response.json();
        this.products = data;
      } catch (error) {
        console.error("Error fetching products:", error);
        alert("Hubo un error al cargar los productos. Intente de nuevo.");
      }
    },
    async fetchSubcategories() {
      try {
        const response = await fetch("https://humobarculinario.com/api/subcategorias_get.php");
        if (!response.ok) {
          throw new Error("Error al obtener las subcategorías");
        }
        const data = await response.json();
        this.subcategories = data; // Guardamos las subcategorías
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        alert("Hubo un error al cargar las subcategorías. Intente de nuevo.");
      }
    },
    changePage(page) {
      this.currentPage = page;
    },
    translateStatus(status) {
      return status === "AVAILABLE" ? "DISPONIBLE" : "NO DISPONIBLE";
    },
    async addProduct() {
      if (!this.newProduct.name || !this.newProduct.price || !this.newProduct.subcategory_id) {
        alert("Por favor, complete los campos obligatorios.");
        return;
      }
      this.isLoading = true;
      try {
        const response = await fetch("https://humobarculinario.com/api/vinos_nuevo.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.newProduct)
        });
        if (!response.ok) {
          throw new Error("Error al agregar el producto");
        }
        alert("Producto agregado exitosamente");
        this.showPopup = false;
        this.fetchProducts();
      } catch (error) {
        console.error("Error al agregar producto:", error);
        alert("Hubo un error al agregar el producto. Intente de nuevo.");
      } finally {
        this.isLoading = false;
      }
    },
    openEditPopup(product) {
      this.editProduct = {
        ...product,
        subcategory_id: product.subcategories.length ? product.subcategories[0].subcategory_id : null, // Establecer subcategory_id correctamente
      };
      this.showEditPopup = true;
    },
    async editProductSubmit() {
      if (!this.editProduct.name || !this.editProduct.price || !this.editProduct.subcategory_id) {
        alert("Por favor, complete los campos obligatorios.");
        return;
      }
      this.isEditing = true;
      try {
        console.log("Editando producto:", this.editProduct); // Verifica que el producto está siendo enviado correctamente
        const response = await fetch(`https://humobarculinario.com/api/vinos_editar.php?id=${this.editProduct.id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(this.editProduct)
        });
        if (!response.ok) {
          throw new Error("Error al editar el producto");
        }
        alert("Producto editado exitosamente");
        this.showEditPopup = false;
        this.fetchProducts();
      } catch (error) {
        console.error("Error al editar producto:", error);
        alert("Hubo un error al editar el producto. Intente de nuevo.");
      } finally {
        this.isEditing = false;
      }
    },
    openDeletePopup(productId) {
      this.deleteProductId = productId;
      this.showDeletePopup = true;
    },
    async deleteProduct() {
      this.isDeleting = true;
      try {
        const response = await fetch(`https://humobarculinario.com/api/producto_eliminar.php?id=${this.deleteProductId}`, {
          method: "POST"
        });
        if (!response.ok) {
          throw new Error("Error al eliminar el producto");
        }
        alert("Producto eliminado exitosamente");
        this.showDeletePopup = false;
        this.fetchProducts();
      } catch (error) {
        console.error("Error al eliminar producto:", error);
        alert("Hubo un error al eliminar el producto. Intente de nuevo.");
      } finally {
        this.isDeleting = false;
      }
    }
  },
  mounted() {
    this.fetchProducts();
    this.fetchSubcategories(); // Cargar las subcategorías al montar el componente
  }
};
</script>

<template>
  <Layout>
    <div class="menu-container">
      <div class="header">
        <h5>PRODUCTOS</h5>
        <input type="text" v-model="searchQuery" placeholder="Buscar..." class="search-input" />
        <button class="add-button" @click="showPopup = true">AGREGAR NUEVO</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Nombre del producto</th>
            <th>Descripción</th>
            <th>Precio</th>
            <th>Moneda</th>
            <th>Subcategoría</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in paginatedProducts" :key="index">
            <td>{{ product.name }}</td>
            <td>{{ product.description }}</td>
            <td>${{ product.price }}</td>
            <td>MXN</td>
            <td>
              <div v-for="subcategory in product.subcategories" :key="subcategory.subcategory_id">
                {{ subcategory.subcategory_name }}
              </div>
            </td>
            <td>
              <button class="icon-button" @click="openEditPopup(product)">✏️</button>
              <button class="icon-button" @click="openDeletePopup(product.id)">🗑️</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="totalPages > 1">
        <button v-for="page in totalPages" :key="page" @click="changePage(page)" :class="{'active': page === currentPage}">
          {{ page }}
        </button>
      </div>
    </div>

    <!-- Popup para agregar producto -->
    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <h3>Agregar Producto</h3>
        <label>Nombre:</label>
        <input type="text" v-model="newProduct.name" required />
        <label>Descripción:</label>
        <input type="text" v-model="newProduct.description" />
        <label>Precio:</label>
        <input type="number" v-model="newProduct.price" required />
        <label>Subcategoría:</label>
        <select v-model="newProduct.subcategory_id" required>
          <option v-for="subcategory in subcategories" :key="subcategory.subcategory_id" :value="subcategory.subcategory_id">
            {{ subcategory.subcategory_name }}
          </option>
        </select>
        <div class="popup-buttons">
          <button class="add-button" @click="addProduct" :disabled="isLoading">
            {{ isLoading ? 'Agregando...' : 'Agregar' }}
          </button>
          <button class="cancel-button" @click="showPopup = false">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Cargando Indicador -->
    <div v-if="isLoading || isEditing || isDeleting" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>

    <!-- Popup para editar producto -->
    <div v-if="showEditPopup" class="popup">
      <div class="popup-content">
        <h3>Editar Producto</h3>
        <label>Nombre:</label>
        <input type="text" v-model="editProduct.name" required />
        <label>Descripción:</label>
        <input type="text" v-model="editProduct.description" />
        <label>Precio:</label>
        <input type="number" v-model="editProduct.price" required />
        <label>Subcategoría:</label>
        <select v-model="editProduct.subcategory_id" required>
          <option v-for="subcategory in subcategories" :key="subcategory.subcategory_id" :value="subcategory.subcategory_id">
            {{ subcategory.subcategory_name }}
          </option>
        </select>
        <div class="popup-buttons">
          <button class="add-button" @click="editProductSubmit" :disabled="isEditing">
            {{ isEditing ? 'Editando...' : 'Guardar' }}
          </button>
          <button class="cancel-button" @click="showEditPopup = false">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Popup para eliminar producto -->
    <div v-if="showDeletePopup" class="popup">
      <div class="popup-content">
        <h3>¿Estás seguro de eliminar este producto?</h3>
        <div class="popup-buttons">
          <button class="delete-button" @click="deleteProduct" :disabled="isDeleting">
            {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
          </button>
          <button class="cancel-button" @click="showDeletePopup = false">Cancelar</button>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.menu-container {
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.add-button {
  background-color: purple;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.available {
  color: green;
  font-weight: bold;
}
.sold-out {
  color: red;
  font-weight: bold;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
  font-size: 16px;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.pagination button {
  margin: 2px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}
.pagination .active {
  background: purple;
  color: white;
}
/* Cargando overlay y spinner */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.loading-spinner {
  border: 4px solid #f3f3f3; /* Fondo gris claro */
  border-top: 4px solid purple; /* Color de la parte que gira */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 300px;
}
.popup label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}
.popup input, .popup select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.popup-buttons {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.add-button, .delete-button {
  background-color: #4e583c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}
.add-button:hover, .delete-button:hover {
  background-color: black;
}
.cancel-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  border: 1px solid black;
}
.cancel-button:hover {
  background-color: white;
  border: 1px solid black;
  color: black;
}
</style>
